var map = {
	"./bg-1.webp": 8939,
	"./bg-2-alt.webp": 7734,
	"./bg-2.webp": 1863,
	"./bg-3.webp": 7791,
	"./card-h1.webp": 8172,
	"./card-h2.webp": 3027,
	"./card-h3.webp": 5976,
	"./card-h4.webp": 1363,
	"./card-h5.webp": 513,
	"./card-h6.webp": 7772,
	"./card-v1.webp": 5255,
	"./card-v2.webp": 3592,
	"./card-v3.webp": 7353,
	"./card-v4.webp": 6430,
	"./header-1.webp": 1087,
	"./header-2.webp": 1449,
	"./header-3.webp": 3271,
	"./header.webp": 3612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;